import React from 'react';

const DepartAfter = ({ departAfter }) => (
  <p className="text-color-medium-grey text-size-20 text-weight-book" key="depart-after-notice">
    Depart after <span className="important">{departAfter.format('h:mm' )}</span><span className="less-important">{departAfter.format('A')}</span>
  </p>
);

export default DepartAfter;
